// src/services/patientVisitApi.js
//
// Patient-side signed visits and prescription PDF
// (docs/visit-workflow-contract.md — "Visit" and "Prescription" patient endpoints).
// Uses the shared axios instance so the JWT and session-expiry handling apply.

import api from './api';

// A 403 on these is "not allowed" (e.g. another patient's visit id), not an
// expired login: without this flag the axios interceptor in api.js would run
// handleSessionExpired() and log the patient out. 401 still ends the session.
const OPTS = { treat403AsForbidden: true };

export const patientVisitApi = {
  /** SIGNED visits only -> VisitListItem[] {visitId, date, doctorName, diagnosisHeadline} */
  list: (patientId) =>
    api.get(`/patients/${patientId}/visits`, OPTS).then(r => r.data),

  /** -> VisitSummary. 404 when not signed or not this patient's. */
  get: (patientId, visitId) =>
    api.get(`/patients/${patientId}/visits/${visitId}`, OPTS).then(r => r.data),

  /** -> Blob (application/pdf) of a signed prescription. */
  prescriptionPdf: (patientId, prescriptionId) =>
    api
      .get(`/patients/${patientId}/prescriptions/${prescriptionId}/pdf`, { ...OPTS, responseType: 'blob' })
      .then(r => r.data),
};

export default patientVisitApi;
